module.exports = __webpack_public_path__ + "static/media/volume.506fac62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volume.png
// module id = 638
// module chunks = 0